import React from 'react';

const ViewCommitment = () => {
  return (
    <p>view commitment</p>
  )
}

export default ViewCommitment;
